import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app/app.reducer';
import { CajaProvider } from '../../caja/caja';
import { SetParametrosgeneralesAction,UnsetParametrosgeneralesAction } from '../../../pages/parametros-generales/state/parametrosgenerales/parametrosgenerales.accions';
import { NUBE_AWS } from '../../../config/url.servicio';
import { Storage } from '@ionic/storage'

@Injectable()
export class ParametrosGeneralesRedux {

  constructor(private store: Store<AppState>,
    public servicio: CajaProvider,private storage: Storage,) {
  }

   buscarParametrosGeneralesStore() {
    return new Promise((resolve, reject) => {
       this.store.select(store => store.parametrosGenerales).subscribe((parametrosGenerales) => {
         return resolve(parametrosGenerales)
       })
     });
   }

   async buscarParametrosGeneralesRedux(companiasId: any, usuariosId: any, nombreUsuario?: string){
    let usuarioIngreso = await this.storage.get('usuariosId');
    let usuarioIdstorage = usuarioIngreso;
    if(usuarioIdstorage) {
      usuariosId = usuarioIdstorage
    } else {
      let usuariosIdAsync = await localStorage.getItem('usuariosId')
      if(usuariosIdAsync && usuariosId == undefined) {
        usuariosId = usuariosIdAsync
      }
    }

   this.servicio.buscarParametrosGeneralesPedidosSalonRedux(companiasId, usuariosId).subscribe((data) => {
    if(NUBE_AWS) {
      let dataJson = JSON.parse(data['_body']).data
      dataJson[0][0].bluetooth = dataJson[0][0].bluetooth === 'B' ? true : false;
      dataJson[0][0].manejaImpresoPorDefecto = dataJson[0][0].manejaImpresoPorDefecto == 0 ? false : true;
      dataJson[0][0].manejaCodigoDeBarras = dataJson[0][0].manejaCodigoDeBarras === 'N' ? false : true;
      dataJson[0][0].creaProductoRapidoDesdeCaja = dataJson[0][0].creaProductoRapidoDesdeCaja === 'N' ? false : true;
      dataJson[0][0].devolverVenta = dataJson[0][0].devolverVenta == 'N' ? false : true;
      dataJson[0][0].usuariosId = usuariosId;
      dataJson[0][0].nombreUsuario = nombreUsuario == undefined ? '' : nombreUsuario;
      dataJson[0][0].manejaPlanDePagosEnCuentasPorCobrar = dataJson[0][0].manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;
      dataJson[0][0].mac = dataJson[0][0].mac == undefined ? '' :  dataJson[0][0].mac;
      dataJson[0][0].cambiarPrecioEnLosProductos = dataJson[0][0].cambiarPrecioEnLosProductos == 'N' ? false :  true;
      dataJson[0][0].creaTurno = dataJson[0][0].creaTurno == 'S' ? true : false;
      dataJson[0][0].manejaDescuentoPorPorcentaje = dataJson[0][0].manejaDescuentoPorPorcentaje == 'S' ? true : false;
      dataJson[0][0].controlaImpresorasEnRed = dataJson[0][0].controlaImpresorasEnRed == 'S' ? true : false;
      dataJson[0][0].ip = dataJson[0][0].ip;
      dataJson[0][0].datosCreditos = dataJson[0][0].datosCreditos;
      dataJson[0][0].datosGenerales = dataJson[0][0].datosGenerales;

      localStorage.setItem("ipAddress", dataJson[0][0].ip);
      localStorage.setItem("puerto", dataJson[0][0].puerto);
      localStorage.setItem("protocolohttps", dataJson[0][0].protocolohttps);
      localStorage.setItem("datosCreditos", dataJson[0][0].datosCreditos);
      localStorage.setItem("datosGenerales", dataJson[0][0].datosGenerales);
      localStorage.setItem("usuariosId", dataJson[0][0].usuariosId);


      dataJson[1][0].administrador = dataJson[1][0].administrador == 0 ? false : true;
      dataJson[1][0].nombreCompania = dataJson[1][0].nombreCompania == undefined ? '' :  dataJson[1][0].nombreCompania;
      dataJson[1][0].nombreCargo = dataJson[1][0].nombreCargo == undefined ? '' :  dataJson[1][0].nombreCargo;
      dataJson[1][0].nitCompania = dataJson[1][0].nitCompania == undefined ? '' :  dataJson[1][0].nitCompania;
      dataJson[1][0].direccion = dataJson[1][0].direccion == undefined ? '' :  dataJson[1][0].direccion;
      dataJson[1][0].telefonos = dataJson[1][0].telefonos == undefined ? '' :  dataJson[1][0].telefonos;
      localStorage.setItem("nitCompania", dataJson[1][0].nitCompania);
      localStorage.setItem("direccion", dataJson[1][0].direccion);
      localStorage.setItem("telefonos", dataJson[1][0].telefonos);
      localStorage.setItem("administrador", dataJson[1][0].administrador);
      this.store.dispatch(new UnsetParametrosgeneralesAction())
      this.store.dispatch(new SetParametrosgeneralesAction(dataJson));
    } else {
    }
  }, (error) => {
    console.log(error);
  })}

}



// WEBPACK FOOTER //
// ./src/providers/redux/parametrosgenerales/parametrosgenerales.ts